// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".span4[data-v-740cb8d8] {\n  background: #6680f4;\n  color: #fff;\n  display: inline-block;\n  height: 0.26rem;\n  width: 0.26rem;\n  line-height: 0.26rem;\n  text-align: center;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 0.14rem;\n  margin-right: 0.05rem;\n}\ni[data-v-740cb8d8] {\n  font-size: 0.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
